import { Box, Button, Heading, MenuButton, Spinner, Text, Menu, MenuItem, MenuList, useToast, Modal, ModalOverlay, ModalContent, ModalHeader, ModalFooter, ModalBody, ModalCloseButton, Input, FormControl, FormLabel, useDisclosure, Image, Grid } from '@chakra-ui/react';
import { useState } from "react"
import { useNavigate } from 'react-router-dom';
import { Light as SyntaxHighlighter } from 'react-syntax-highlighter';
import { androidstudio } from 'react-syntax-highlighter/dist/esm/styles/hljs';

const VsBox = ({ code }) => {
    const toast = useToast()

    const copyToClipboard = (ele) => {
        navigator.clipboard.writeText(ele);
        toast({ title: 'Code Copied', status: 'warning', duration: 1000, isClosable: true, position: 'top' })
    }

    return (
        <Box position={'relative'}>
            <Button onClick={() => copyToClipboard(code)} position={'absolute'} top={'0'} right={'0'} bg={'RGB(250, 250, 250, 0.8)'} borderRadius={'0'}>Copy</Button>
            <SyntaxHighlighter language="javascript" style={androidstudio} customStyle={{ overflow: 'hidden' }} >
                {code}
            </SyntaxHighlighter>
        </Box>
    );
}

export const GridGenerator = () => {
    const { isOpen: IsOpen, onOpen: OnOpen, onClose: OnClose } = useDisclosure()
    const [box, setBox] = useState(9);
    const [col, setCol] = useState(['1fr', '1fr', '1fr', '1fr'])
    const [row, setRow] = useState(['1fr', '1fr'])
    const [cgap, setCgap] = useState(10)
    const [rgap, setRgap] = useState(10)
    const navigate = useNavigate()

    const handleBox = (value) => {
        if (value >= 1 && value<=100) {
            setBox(value)
        }
    }

    const handleCol = ({ value, index }) => {
        setCol(prevCol => {
            const newArray = [...prevCol]
            newArray[index] = value;
            return newArray;
        });

    };

    const handleColAdd = () => {
        setCol(prevCol => {
            const newArray = [...prevCol]
            newArray.push('1fr')
            return newArray;
        })

    }

    const handleColMinus = () => {
        if (col.length != 1) {
            setCol(prevCol => {
                const newArray = [...prevCol]
                newArray.pop()
                return newArray;
            })
        }
    }

    const handleRow = ({ value, index }) => {
        setRow(prevCol => {
            const newArray = [...prevCol]
            newArray[index] = value;
            return newArray;
        });

    }

    const handleRowAdd = () => {
        if (box >= 1) {
            setBox((e) => e + col.length)
        }
    }

    const handleRowMinus = () => {
        if (box >= 1) {
            setBox((e) => e - col.length)
        }
    }

    if (col.length > box) {
        col.pop()
    }

    if (Math.ceil(box / col.length) > row.length) {
        setRow(prevCol => {
            const newArray = [...prevCol]
            newArray.push('1fr')
            return newArray;
        });
    } else if (Math.ceil(box / col.length) < row.length) {
        setRow(prevCol => {
            const newArray = [...prevCol]
            newArray.pop()
            return newArray;
        });
    }

    var Html = `<div class='Grid_Container'>
<!-- <div>Add ${box} div</div> -->   
</div>`

    var style = `.Grid_Container {
    display: grid;
    grid-template-columns: ${col.join(' ')};
    grid-template-rows: ${row.join(' ')};
    gap: ${cgap}px ${rgap}px;
    grid-auto-flow: row;
}
.Grid_Container > div {
    border: 1px solid grey;
    padding: 7px; /* Change according to you */
}`

    var style_Repeat = `.Grid_Container {
    display: grid;
    grid-template-columns: repeat(${col.length},1fr);
    gap: ${cgap}px ${rgap}px;
    grid-auto-flow: row;
}
.Grid_Container > div {
    border: 1px solid grey;
    padding: 7px; /* Change according to you */
}`

    var Chakra_ui = `
<Grid gridTemplateColumns={${col.join(' ')}} gridTemplateRows={${row.join(' ')}} gap={${cgap}px ${rgap}px}>

</Grid>`

    var Chakra_ui_repeat = `
<Grid gridTemplateColumns={repeat(${col.length},1fr)} gap={${cgap}px ${rgap}px}>

</Grid>`


    return (
        <Box bg={'#1E1E1E'} h={'100vh'} overflow={'scroll'}>
            <style>{`::-webkit-scrollbar {display: none;}`}</style>

            {/* navbar */}
            <Box display={'flex'} justifyContent={'space-between'} alignItems={'center'} p={'10px'}>
                <Box display={'flex'} gap={'10px'}>
                    <Text color={'#F44336'} fontSize={'30px'} fontWeight={'bold'}>|| </Text>
                    <Text onClick={() => navigate('/UiMaster')} cursor={'pointer'} color={'white'} fontSize={'30px'} fontWeight={'bold'}>Ui Master</Text>
                </Box>
                <Box>
                <Text color={'white'} fontSize={'15px'} fontWeight={'bold'}>○ Grid Generator</Text>
                </Box>
            </Box>

            {/* content */}

            <Box w={['97%', '95%', '85%']} m={'1cm auto'} display={'flex'} flexDirection={['column', 'column', 'row']} justifyContent={'space-between'} gap={'20px'} color={'whiteAlpha.900'}>
                <Box w={['95%', '90%', '60%']} m={'auto'}>
                    <Box display={'flex'} justifyContent={'right'} mb={'10px'}>
                        <Grid w={'88%'} gridTemplateColumns={col.join(' ')} gap={`${cgap}px ${rgap}px`}>
                            {col && col?.map((ele, index) => (
                                <Input fontSize={['12px', '14px', '15px']} onChange={(e) => handleCol({ value: e.target.value, index })} textAlign={'center'} value={ele} border={'1px solid #29B6F6'} m={'7px 0'} p={'10px'} key={index} />
                            ))}
                        </Grid>
                    </Box>
                    <Box display={'flex'} justifyContent={'space-between'} overflow={'hidden'}>
                        <Grid gridTemplateRows={row.join(' ')} w={'10%'} gap={`${cgap}px ${rgap}px`}>
                            {row && row?.map((ele, index) => (
                                <Input fontSize={['12px', '14px', '15px']} onChange={(e) => handleRow({ value: e.target.value, index })} h={'100%'} textAlign={'center'} value={ele} border={'1px solid #29B6F6'} p={'10px'} key={index} />
                            ))}
                        </Grid>

                        <Box w={'88%'}>
                            <Grid gridTemplateColumns={col.join(' ')} gridTemplateRows={row.join(' ')} gap={`${cgap}px ${rgap}px`}>
                                {Array.from({ length: box }, (_, index) => (
                                    <Box fontSize={['12px', '14px', '15px']} key={index} border={'1px solid grey'} display={'flex'} justifyContent={'center'} alignItems={'center'} p={'10px'}>+</Box>
                                ))}
                            </Grid>
                        </Box>
                    </Box>

                    {/* management */}
                    <Box w={'100%'} mt={'1cm'}>
                        <Box display={'flex'} m={'10px 0'} justifyContent={'space-between'} alignItems={'center'}>
                            <Text fontSize={['14px', '15px', '14.5px', '17px']} fontWeight={'medium'}>Elements :</Text>
                            <Box display={'flex'} gap={'10px'}>
                                <Button border={'1.5px solid #F44336'} bg={'RGB(244, 67, 54, 0.1)'} color={'white'} w={'70px'} h={'40px'} onClick={()=>setBox((e)=> e-1)}>-</Button>
                                <Input textAlign={'center'} onChange={(e) => handleBox(+e.target.value)} value={box} border={'1px solid grey'} w={'100px'} type="number" />
                                <Button border={'1.5px solid #F44336'} bg={'RGB(244, 67, 54, 0.1)'} color={'white'} w={'70px'} h={'40px'} onClick={()=>setBox((e)=> e+1)}>+</Button>
                            </Box>
                        </Box>
                        <Box display={'flex'} m={'10px 0'} justifyContent={'space-between'} alignItems={'center'}>
                            <Text fontSize={['14px', '15px', '14.5px', '17px']} fontWeight={'medium'}>Columns :</Text>
                            <Box display={'flex'} gap={'10px'}>
                                <Button border={'1.5px solid #F44336'} bg={'RGB(244, 67, 54, 0.1)'} color={'white'} w={'70px'} h={'40px'} onClick={handleColMinus}>-</Button>
                                <Box w={'100px'} h={'40px'} textAlign={'center'} display={'flex'} justifyContent={'center'} alignItems={'center'} borderRadius={'7px'} border={'1px solid grey'}>{col.length}</Box>
                                <Button border={'1.5px solid #F44336'} bg={'RGB(244, 67, 54, 0.1)'} color={'white'} w={'70px'} h={'40px'} onClick={handleColAdd}>+</Button>
                            </Box>
                        </Box>
                        <Box display={'flex'} m={'10px 0'} justifyContent={'space-between'} alignItems={'center'}>
                            <Text fontSize={['14px', '15px', '14.5px', '17px']} fontWeight={'medium'}>Rows :</Text>
                            <Box display={'flex'} gap={'10px'}>
                                <Button border={'1.5px solid #F44336'} bg={'RGB(244, 67, 54, 0.1)'} color={'white'} w={'70px'} h={'40px'} onClick={handleRowMinus}>-</Button>
                                <Box w={'100px'} h={'40px'} textAlign={'center'} display={'flex'} justifyContent={'center'} alignItems={'center'} borderRadius={'7px'} border={'1px solid grey'}>{row.length}</Box>
                                <Button border={'1.5px solid #F44336'} bg={'RGB(244, 67, 54, 0.1)'} color={'white'} w={'70px'} h={'40px'} onClick={handleRowAdd}>+</Button>
                            </Box>
                        </Box>
                        <Box display={'flex'} m={'10px 0'} justifyContent={'space-between'} alignItems={'center'}>
                            <Text fontSize={['14px', '15px', '14.5px', '17px']} fontWeight={'medium'}> Column Gap (px) :</Text>
                            <Box display={'flex'} gap={'10px'}>
                                <Button border={'1.5px solid #F44336'} bg={'RGB(244, 67, 54, 0.1)'} color={'white'} w={'70px'} h={'40px'} disabled={cgap == 0} onClick={() => setCgap(cgap - 1)}>-</Button>
                                <Input onChange={(e) => setCgap(+e.target.value)} value={cgap} w={'100px'} h={'40px'} border={'1px solid grey'} textAlign={'center'} />
                                <Button border={'1.5px solid #F44336'} bg={'RGB(244, 67, 54, 0.1)'} color={'white'} w={'70px'} h={'40px'} onClick={() => setCgap(cgap + 1)}>+</Button>
                            </Box>
                        </Box>
                        <Box display={'flex'} m={'10px 0'} justifyContent={'space-between'} alignItems={'center'}>
                            <Text fontSize={['14px', '15px', '14.5px', '17px']} fontWeight={'medium'}>Row Gap (px) :</Text>
                            <Box display={'flex'} gap={'10px'}>
                                <Button border={'1.5px solid #F44336'} bg={'RGB(244, 67, 54, 0.1)'} color={'white'} w={'70px'} h={'40px'} disabled={rgap == 0} onClick={() => setRgap(rgap - 1)}>-</Button>
                                <Input onChange={(e) => setRgap(+e.target.value)} value={rgap} w={'100px'} h={'40px'} border={'1px solid grey'} textAlign={'center'} />
                                <Button border={'1.5px solid #F44336'} bg={'RGB(244, 67, 54, 0.1)'} color={'white'} w={'70px'} h={'40px'} onClick={() => setRgap(rgap + 1)}>+</Button>
                            </Box>
                        </Box>
                    </Box>
                </Box>
                {/* Code Element */}
                <Box w={['95%', '90%', '40%']} m={'0 auto'} overflow={'hidden'}>
                    <VsBox code={Html} />
                    <br />
                    <VsBox code={style} />
                    <br />
                    <Button onClick={() => OnOpen()} w={'100%'}>ADVANCE</Button>
                </Box>
            </Box>

            {/* Advance Copy */}
            <Modal isOpen={IsOpen} onClose={OnClose}>
                <ModalOverlay />
                <ModalContent mt={'1cm'} bg={'white'} boxShadow={'#373131 0px 0px 30px'} maxW={['95%', '70%', '60%', '40%']} borderRadius={'20px'}>
                    <ModalCloseButton />
                    <ModalBody>
                        <Box color={'blue.400'} m={'10px 0 5px 0'} fontWeight={'medium'} fontFamily={'sans-serif'}>(Repeat Function)</Box>

                        <VsBox code={Html} />
                        <br />
                        <VsBox code={style_Repeat} />

                        <Box color={'blue.400'} m={'10px 0 5px 0'} fontWeight={'medium'} fontFamily={'sans-serif'}>Chakra UI</Box>
                        <VsBox code={Chakra_ui} />
                        <Box color={'blue.400'} m={'10px 0 5px 0'} fontWeight={'medium'} fontFamily={'sans-serif'}>Chakra UI ( Repeat Function )</Box>
                        <VsBox code={Chakra_ui_repeat} />
                    </ModalBody>

                </ModalContent>
            </Modal>
        </Box>
    )
}